import * as React from 'react';
import { Route, Routes, useParams } from "react-router-dom"
import { Websites } from './Websites';
import { Deploy } from './Deploy';
import { Website } from './Website';
import { NotFound } from '../NotFound';
import { AppSection } from '../../components/AppSection';
import { StaticFileStringEditor } from '../../components/Websites/StaticFileStringEditor';
import { CollectionItemForm } from './CollectionItemForm';
import { SingleForm } from './SingleForm';
import { SingleFormRaw, CollectionItemFormRaw } from './FormsRaw';

const THEME = 'simple-business';

function WebsitesRoute() {
    return (<Websites theme={THEME} />);
}

function SingleRoute() {
    const params = useParams();
    return (<SingleForm themeKey={THEME} singleKey={params.item!} websiteKey={params.site!} />);
}

function SingleRawRoute() {
    const params = useParams();
    return (<SingleFormRaw singleKey={params.item!} websiteKey={params.site!} />);
}

function CollectionItemRoute() {
    const params = useParams();
    return (<CollectionItemForm themeKey={THEME} collectionKey={params.collection!} pageKey={params.item!} websiteKey={params.site!} />);
}

function CollectionItemRawRoute() {
    const params = useParams();
    return (<CollectionItemFormRaw collectionKey={params.collection!} collectionItemKey={params.item!} websiteKey={params.site!} />);
}

function StaticFileEditorRoute({ assets }: { assets: boolean }) {
    const params = useParams();
    const path = params['*'] || '';
    return (<StaticFileStringEditor websiteKey={params.site!} path={path} assets={assets} />);
}

function WebsiteRoute() {
    const params = useParams();
    return (<Website websiteKey={params.site!} themeKey={THEME} />);
}

function DeployRoute() {
    const params = useParams();
    return (<Deploy websiteKey={params.site!} themeKey={THEME} />);
}

export class DynamicWebsites extends React.Component<any, any>{

    public render() {

        return (<React.Fragment>
            <AppSection section="websites/simple-business" />
            <Routes>
                <Route path=":site/deploy" element={<DeployRoute />} />
                <Route path=":site/collections/:collection/:item/raw" element={<CollectionItemRawRoute />} />
                <Route path=":site/collections/:collection/:item" element={<CollectionItemRoute />} />
                <Route path=":site/singles/:item" element={<SingleRoute />} />
                <Route path=":site/singles/:item/raw" element={<SingleRawRoute />} />
                <Route path=":site/static-file-editor/*" element={<StaticFileEditorRoute assets={false} />} />
                <Route path=":site/assets-file-editor/*" element={<StaticFileEditorRoute assets={true} />} />
                <Route path=":site" element={<WebsiteRoute />} />
                <Route path="" element={<WebsitesRoute />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </React.Fragment>)
    }
}
